import { Dayjs } from "dayjs"

export const getMessageTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"

export const isFutureMessageDate = (date: Dayjs | null, now: Date = new Date()) => !!date && date.isAfter(now)
